import { Trans, useLingui } from "@lingui/react/macro";
import { Anchor } from "@mantine/core";
import CookieConsent from "react-cookie-consent";
import { Link } from "react-router-dom";
import { userStore } from "@/mobx/rootStore";
import {
	maybeStartBugsnag,
	setBugsnagUser,
	stopBugsnagSession,
} from "@/utils/bugsnag/bugsnagConsent";
import { recordConsent } from "@/utils/consent/consent";
import { CONSENT_COOKIE_NAME } from "@/utils/consent/constants";
import { notifyConsentChanged } from "@/utils/hooks/useConsentPending";

const containerStyle = {
	background: "var(--mantine-color-body)",
	color: "var(--mantine-color-text)",
	boxShadow: "var(--mantine-shadow-lg)",
	display: "flex",
	flexWrap: "wrap",
	justifyContent: "space-between",
	alignItems: "center",
	gap: "0.75rem 1.5rem",
	padding: "1rem 1.5rem",
	zIndex: 500,
};

// Aceptar y rechazar comparten estilo: misma prominencia, sin dark patterns.
const buttonStyle = {
	background: "var(--mantine-primary-color-filled)",
	color: "var(--mantine-color-white)",
	border: "none",
	borderRadius: "var(--mantine-radius-sm)",
	padding: "0.5rem 1rem",
	cursor: "pointer",
	fontSize: "var(--mantine-font-size-sm)",
	fontWeight: 500,
};

const declineButtonStyle = { ...buttonStyle };

const contentStyle = {
	flex: "1 1 320px",
	margin: 0,
	fontSize: "var(--mantine-font-size-sm)",
};

export default function CookieConsentBanner() {
	const { t } = useLingui();

	const handleAccept = () => {
		recordConsent({ accepted: true, source: "banner", userId: userStore.data?.id });
		maybeStartBugsnag();
		setBugsnagUser(userStore.data?.id, userStore.data?.email, userStore.data?.username);
		notifyConsentChanged();
	};

	const handleDecline = () => {
		recordConsent({ accepted: false, source: "banner", userId: userStore.data?.id });
		stopBugsnagSession();
		notifyConsentChanged();
	};

	return (
		<CookieConsent
			location="bottom"
			cookieName={CONSENT_COOKIE_NAME}
			expires={365}
			enableDeclineButton
			buttonText={t`Aceptar`}
			declineButtonText={t`Rechazar`}
			ariaAcceptLabel={t`Aceptar cookies`}
			ariaDeclineLabel={t`Rechazar cookies`}
			style={containerStyle}
			buttonStyle={buttonStyle}
			declineButtonStyle={declineButtonStyle}
			contentStyle={contentStyle}
			onAccept={handleAccept}
			onDecline={handleDecline}
		>
			<Trans>
				Usamos cookies técnicas para que la app funcione y, solo si lo aceptas, cookies de
				diagnóstico de errores.{" "}
				<Anchor component={Link} to="/legal/cookies" inherit underline="always">
					Más información
				</Anchor>
			</Trans>
		</CookieConsent>
	);
}
